import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { History, Loader2 } from 'lucide-react';
import api from '../../utils/axios';
import { formatoMonto } from '../compartidos/useAnalisis';
import { ESTADO_EPISODIO, fFecha } from './episodioUtils';

// G2 (Historial): episodios anteriores del mismo monitor para el cliente, con su conclusión.
export const EpisodioHistorial = ({ caseId, episodioId }) => {
  const navigate = useNavigate();
  const [filas, setFilas] = useState(null);
  useEffect(() => {
    let vivo = true;
    setFilas(null);
    api.get(`/cases/${caseId}/episodios/${episodioId}/historial`)
      .then((r) => vivo && setFilas(r.data.historial || []))
      .catch(() => vivo && setFilas([]));
    return () => { vivo = false; };
  }, [caseId, episodioId]);

  if (!filas) return <div className="flex justify-center py-8"><Loader2 className="animate-spin text-slate-400" size={20} /></div>;
  if (!filas.length) {
    return <p className="py-8 text-center text-sm text-slate-400" data-testid="episodio-historial-vacio">No hay episodios anteriores de este monitor para el cliente.</p>;
  }
  return (
    <ol className="space-y-2" data-testid="episodio-historial">
      {filas.map((h) => {
        const est = ESTADO_EPISODIO[h.estado] || ESTADO_EPISODIO.VENCIDO;
        return (
          <li key={h.id} className="rounded-lg border border-slate-200 bg-white p-3 text-xs" data-testid={`episodio-historial-${h.id}`}>
            <div className="flex flex-wrap items-center gap-2">
              <History size={13} className="text-slate-400" />
              <span className="font-mono text-slate-500">{fFecha(h.fecha)}</span>
              <span className={`rounded-full border px-2 py-0.5 text-[10px] font-semibold ${est.c}`}>{est.label}</span>
              <span className="text-slate-500">{h.cantidad} mov. · {formatoMonto(h.monto)}</span>
              {h.caso_id !== caseId && (
                <button type="button" onClick={() => navigate(`/m/gestion-de-casos/caso/${h.caso_id}`)}
                  className="ml-auto text-sky-700 hover:underline">{h.caso_titulo || 'Abrir caso'}</button>
              )}
            </div>
            {(h.conclusion || h.motivo_descarte) && (
              <p className="mt-1.5 text-slate-700">
                {h.motivo_descarte && <span className="mr-1 font-semibold">{h.motivo_descarte}:</span>}{h.conclusion}
              </p>
            )}
          </li>
        );
      })}
    </ol>
  );
};

export default EpisodioHistorial;
